<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-hidden font-prompt">

  <!-- 1. Header Bar (Dark Gradient VIP Theme) -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-6 pb-7 rounded-b-[2.5rem] shadow-lg z-10 shrink-0 text-white border-b border-white/5">

    <!-- Back Button -->
    <div class="absolute left-4 top-4.5 z-20">
      <button
        class="w-9 h-9 p-2 bg-white/10 hover:bg-white/20 backdrop-blur-md shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-white/10 text-white outline-none"
        (click)="goback()">
        <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
      </button>
    </div>

    <!-- Title & Description -->
    <div class="flex flex-col items-center justify-center mt-1.5 text-center select-none">
      <h2 class="text-base font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "ตั้งค่าการใช้งาน" : "System Settings" }}
      </h2>
      <p class="text-[9px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === "TH" ? "ปรับแต่งภาษาและรับการแจ้งเตือน" : "Customize language & alerts" }}
      </p>
    </div>
  </div>

  <!-- 2. Main Settings Area -->
  <div class="flex-1 overflow-y-auto custom-scrollbar px-6 pt-5 pb-24 space-y-4 text-left">

    <!-- Card Group 1: ภาษา (Language settings) -->
    <div class="bg-white rounded-3xl p-4.5 border border-slate-100/50 shadow-sm space-y-3.5">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 p-2 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
          <img src="icons/translate_orange.svg" class="w-full h-full" />
        </div>
        <div>
          <span class="text-xs font-black text-slate-800 block leading-tight">{{ currentLang === "TH" ? "ภาษาของระบบ" :
            "System Language" }}</span>
          <span class="text-[9px] text-slate-400 font-bold block mt-0.5">{{ currentLang === "TH" ?
            "เลือกภาษาที่ใช้แสดงผลในแอปพลิเคชัน" : "Choose display language of application" }}</span>
        </div>
      </div>

      <!-- Segment Selector Switch -->
      <div class="flex bg-slate-100 rounded-2xl p-1 w-full relative">
        <button (click)="setLang('TH')" [class.bg-white]="selectedLang === 'TH'"
          [class.text-slate-800]="selectedLang === 'TH'" [class.shadow-sm]="selectedLang === 'TH'"
          [class.font-black]="selectedLang === 'TH'" [class.text-slate-400]="selectedLang !== 'TH'"
          class="flex-1 py-2 text-xs font-bold rounded-xl transition-all duration-200 border-none outline-none cursor-pointer">
          ภาษาไทย (TH)
        </button>
        <button (click)="setLang('EN')" [class.bg-white]="selectedLang === 'EN'"
          [class.text-slate-800]="selectedLang === 'EN'" [class.shadow-sm]="selectedLang === 'EN'"
          [class.font-black]="selectedLang === 'EN'" [class.text-slate-400]="selectedLang !== 'EN'"
          class="flex-1 py-2 text-xs font-bold rounded-xl transition-all duration-200 border-none outline-none cursor-pointer">
          English (EN)
        </button>
      </div>
    </div>

    <!-- Card Group 2: การแจ้งเตือน (Alerts settings) -->
    <div class="bg-white rounded-3xl p-4.5 border border-slate-100/50 shadow-sm space-y-4">

      <!-- Section header -->
      <div class="flex items-center gap-3 pb-2.5 border-b border-slate-50">
        <div class="w-8 h-8 p-1.5 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
          <img src="icons/notifications_orange.svg" class="w-full h-full" />
        </div>
        <div>
          <span class="text-xs font-black text-slate-800 block leading-tight">{{ currentLang === "TH" ?
            "การตั้งค่าการแจ้งเตือน" : "Alert Notifications" }}</span>
          <span class="text-[9px] text-slate-400 font-bold block mt-0.5">{{ currentLang === "TH" ?
            "รับข่าวสารความเคลื่อนไหวผ่านไลน์" : "Receive instant alerts in LINE app" }}</span>
        </div>
      </div>

      <!-- Option 1: Vehicle entry -->
      <div class="flex items-center justify-between gap-4">
        <div class="min-w-0">
          <span class="text-xs font-bold text-slate-700 block leading-tight">
            {{ currentLang === "TH" ? "แจ้งเตือนรถเข้าจอด" : "Vehicle Entry Alerts" }}
          </span>
          <span class="text-[9px] text-slate-400 block mt-0.5">
            {{ currentLang === "TH" ? "ส่งข้อความเมื่อรถของคุณเริ่มจอดในพื้นที่" : "Notify when your vehicle enters
            parking lot" }}
          </span>
        </div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
          <input type="checkbox" class="sr-only peer" [(ngModel)]="notifyIn" />
          <div
            class="w-10 h-5.5 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative transition-colors duration-200">
          </div>
          <div
            class="absolute top-0.5 left-0.5  w-4.5 h-4.5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-4.5 shadow-sm">
          </div>
        </label>
      </div>

      <!-- Option 2: Vehicle exit -->
      <div class="flex items-center justify-between gap-4 pt-1">
        <div class="min-w-0">
          <span class="text-xs font-bold text-slate-700 block leading-tight">
            {{ currentLang === "TH" ? "แจ้งเตือนรถออกจอด" : "Vehicle Exit Alerts" }}
          </span>
          <span class="text-[9px] text-slate-400 block mt-0.5">
            {{ currentLang === "TH" ? "ส่งข้อความเมื่อรถของคุณแล่นออกจากพื้นที่" : "Notify when your vehicle exits
            parking lot" }}
          </span>
        </div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
          <input type="checkbox" class="sr-only peer" [(ngModel)]="notifyOut" />
          <div
            class="w-10 h-5.5 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative transition-colors duration-200">
          </div>
          <div
            class="absolute top-0.5 left-0.5 w-4.5 h-4.5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-4.5 shadow-sm">
          </div>
        </label>
      </div>

      <!-- Option 3: Expiry warnings -->
      <div class="flex items-center justify-between gap-4 pt-1">
        <div class="min-w-0">
          <span class="text-xs font-bold text-slate-700 block leading-tight">
            {{ currentLang === "TH" ? "แจ้งเตือนบัตรหมดอายุ" : "Card Expiry Alerts" }}
          </span>
          <span class="text-[9px] text-slate-400 block mt-0.5">
            {{ currentLang === "TH" ? "ส่งข้อความแจ้งเตือนต่ออายุบัตรสมาชิกล่วงหน้า" : "Notify when your member card is
            near expiration" }}
          </span>
        </div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
          <input type="checkbox" class="sr-only peer" [(ngModel)]="notifyExpire" />
          <div
            class="w-10 h-5.5 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative transition-colors duration-200">
          </div>
          <div
            class="absolute top-0.5 left-0.5 w-4.5 h-4.5 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-4.5 shadow-sm">
          </div>
        </label>
      </div>

    </div>

    <!-- Action Buttons -->
    <div class="pt-6 space-y-4">
      <button
        class="w-full bg-amber-400 hover:bg-amber-500 text-slate-800 py-3.5 rounded-2xl font-black text-sm shadow-md active:scale-[0.98] transition-all border-none outline-none cursor-pointer"
        (click)="updateUserSetting()">
        {{ currentLang === "TH" ? "บันทึกการตั้งค่า" : "Save Changes" }}
      </button>
      <!-- 
      <div class="flex justify-center text-xs font-bold text-slate-400 hover:text-slate-600 transition-colors cursor-pointer select-none" (click)="goback()">
        <span>{{ currentLang === "TH" ? "ยกเลิกและย้อนกลับ" : "Cancel & Go back" }}</span>
      </div> -->

      <p class="text-[10px] text-center text-slate-400 font-bold pt-2">version : {{ appVersion }}</p>
    </div>

  </div>

  <!-- Premium Loading Overlay -->
  <app-pss-loading *ngIf="isLoading"></app-pss-loading>

</div>